<template>
  <div class="sim_servers response_table">

    <div v-if="loading" style="height: 100%">
      <h3 style="text-align: center" >
        {{translate('no_data')}}
      </h3>
    </div>

    <table v-else>
      <thead>
        <tr>
          <th scope="col">
            {{ translate('sim_server.client_settings.client_name') }}
          </th>
          <th scope="col">
            {{ translate('sim_server.client_settings.status') }}
          </th>
          <th scope="col">
            {{ translate('sim_server.client_settings.comment') }}
          </th>
          <th scope="col">
            {{ translate('sim_server.client_settings.ts_update') }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
            v-for="(client_settings_item, index) in clients_settings"
            :key="index"
            class="client_settings_item"
            @click="show_info(client_settings_item.id)"
        >
          <td :data-label="translate('sim_server.client_settings.client_name')">
            <span>{{client_settings_item.client_name }}</span>
          </td>
          <td :data-label="translate('sim_server.client_settings.status')">
            <span>{{client_settings_item.status }}</span>
          </td>
          <td :data-label="translate('sim_server.client_settings.comment')">
            <span>{{client_settings_item.comment }}</span>
          </td>
          <td :data-label="translate('sim_server.client_settings.ts_update')">
            <span>{{ get_date(client_settings_item.ts_update) }}</span>
          </td>
        </tr>
      </tbody>
    </table>
   

  </div>
</template>

<script>


export default {
  name: 'RemoteSimClientSettings',
  props: {
    request: {
      type: String,
      default: 'all'
    }
  },

  data () {
    return {
      loading: true,
      clients_settings: {}
    }
  },

  created () {
    this.get_clients_settings()
  },

  methods: {
    get_clients_settings(){
      this.$http.simcard.getClientSettings((response) => {
        this.clients_settings = response.data
        this.loading = false
      })
    }
  },
}
</script>
<style lang='scss' scoped>
  .sim_servers{
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
  }
 </style>
